import { render, staticRenderFns } from "./SettingMember.vue?vue&type=template&id=21e46262&scoped=true&"
import script from "./SettingMember.vue?vue&type=script&lang=js&"
export * from "./SettingMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e46262",
  null
  
)

export default component.exports